import React from 'react';
import { TextButton, IconButton, IconTextButton } from '../../components/Button';
import Input from '../../components/Input/Input';
import TextArea from '../../components/TextArea/TextArea';
import Dialog from '../../components/Dialog/Dialog';
// @ts-ignore
import closeIcon from '../../image-assets/icon.close.svg';
// @ts-ignore
import addIcon from '../../image-assets/icon.add.svg';
import './StyleGuide.css';
import '../../components/Checkbox.css';

const StyleGuide: React.FC = () => {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <div className="style-guide">
      <header className="style-guide-header">
        <h1>Texta Design System</h1>
        <p>A comprehensive guide to the design tokens and components used in Texta</p>
      </header>

      <section className="style-guide-section">
        <h2 id="colors" className="style-guide-section-title">Colors</h2>
        <div className="color-grid">
          <div className="color-item">
            <div className="color-swatch bg-accent"></div>
            <div className="color-info">
              <div className="color-name">Accent</div>
              <div className="color-var">--accent</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-onaccent"></div>
            <div className="color-info">
              <div className="color-name">On Accent</div>
              <div className="color-var">--onaccent</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-surfaceprimary"></div>
            <div className="color-info">
              <div className="color-name">Surface Primary</div>
              <div className="color-var">--surfaceprimary</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-surfacesecondary"></div>
            <div className="color-info">
              <div className="color-name">Surface Secondary</div>
              <div className="color-var">--surfacesecondary</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-surfacetertiary"></div>
            <div className="color-info">
              <div className="color-name">Surface Tertiary</div>
              <div className="color-var">--surfacetertiary</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-text-primary"></div>
            <div className="color-info">
              <div className="color-name">Text Primary</div>
              <div className="color-var">--text-primary</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-text-secondary"></div>
            <div className="color-info">
              <div className="color-name">Text Secondary</div>
              <div className="color-var">--text-secondary</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-divider"></div>
            <div className="color-info">
              <div className="color-name">Divider</div>
              <div className="color-var">--divider</div>
            </div>
          </div>
          <div className="color-item">
            <div className="color-swatch bg-hover"></div>
            <div className="color-info">
              <div className="color-name">Hover</div>
              <div className="color-var">--hover</div>
            </div>
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="typography" className="style-guide-section-title">Typography</h2>
        <div className="typography-grid">
          <div className="typography-item">
            <div className="typography-sample font-huge-title">Huge Title</div>
            <div className="typography-info">
              <div className="typography-name">Huge Title</div>
              <div className="typography-var">--font-huge-title</div>
            </div>
          </div>
          <div className="typography-item">
            <div className="typography-sample font-large-title">Large Title</div>
            <div className="typography-info">
              <div className="typography-name">Large Title</div>
              <div className="typography-var">--font-large-title</div>
            </div>
          </div>
          <div className="typography-item">
            <div className="typography-sample font-title">Title</div>
            <div className="typography-info">
              <div className="typography-name">Title</div>
              <div className="typography-var">--font-title</div>
            </div>
          </div>
          <div className="typography-item">
            <div className="typography-sample font-body">Body</div>
            <div className="typography-info">
              <div className="typography-name">Body</div>
              <div className="typography-var">--font-body</div>
            </div>
          </div>
          <div className="typography-item">
            <div className="typography-sample font-body-bold">Body Bold</div>
            <div className="typography-info">
              <div className="typography-name">Body Bold</div>
              <div className="typography-var">--font-body-bold</div>
            </div>
          </div>
          <div className="typography-item">
            <div className="typography-sample font-caption">Caption</div>
            <div className="typography-info">
              <div className="typography-name">Caption</div>
              <div className="typography-var">--font-caption-1</div>
            </div>
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="spacing" className="style-guide-section-title">Border Radius</h2>
        <div className="radius-grid">
          <div className="radius-item">
            <div className="radius-sample radius-s"></div>
            <div className="radius-info">
              <div className="radius-name">S (8px)</div>
              <div className="radius-var">--radius-s</div>
            </div>
          </div>
          <div className="radius-item">
            <div className="radius-sample radius-sm"></div>
            <div className="radius-info">
              <div className="radius-name">SM (12px)</div>
              <div className="radius-var">--radius-sm</div>
            </div>
          </div>
          <div className="radius-item">
            <div className="radius-sample radius-m"></div>
            <div className="radius-info">
              <div className="radius-name">M (16px)</div>
              <div className="radius-var">--radius-m</div>
            </div>
          </div>
          <div className="radius-item">
            <div className="radius-sample radius-l"></div>
            <div className="radius-info">
              <div className="radius-name">L (24px)</div>
              <div className="radius-var">--radius-l</div>
            </div>
          </div>
          <div className="radius-item">
            <div className="radius-sample radius-xl"></div>
            <div className="radius-info">
              <div className="radius-name">XL (40px)</div>
              <div className="radius-var">--radius-xl</div>
            </div>
          </div>
          <div className="radius-item">
            <div className="radius-sample radius-full"></div>
            <div className="radius-info">
              <div className="radius-name">Full</div>
              <div className="radius-var">--radius-full</div>
            </div>
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="buttons" className="style-guide-section-title">Buttons</h2>
        
        <h3>Button Variants Overview</h3>
        <div className="component-demo">
          <TextButton variant="primary">Primary</TextButton>
          <TextButton variant="secondary">Secondary</TextButton>
          <TextButton variant="text">Text</TextButton>
        </div>
        
        <div className="style-guide-subsection">
          <h3>Text Only Buttons</h3>
          
          <h4>Primary</h4>
          <div className="component-demo">
            <TextButton variant="primary" size="small">Small</TextButton>
            <TextButton variant="primary" size="medium">Medium</TextButton>
            <TextButton variant="primary" size="large">Large</TextButton>
          </div>
          
          <div className="component-demo">
            <TextButton variant="primary" size="small" isLoading>Loading</TextButton>
            <TextButton variant="primary" size="medium" isLoading>Loading</TextButton>
            <TextButton variant="primary" size="large" isLoading>Loading</TextButton>
          </div>
          
          <h4>Secondary</h4>
          <div className="component-demo">
            <TextButton variant="secondary" size="small">Small</TextButton>
            <TextButton variant="secondary" size="medium">Medium</TextButton>
            <TextButton variant="secondary" size="large">Large</TextButton>
          </div>
          
          <div className="component-demo">
            <TextButton variant="secondary" size="small" isLoading>Loading</TextButton>
            <TextButton variant="secondary" size="medium" isLoading>Loading</TextButton>
            <TextButton variant="secondary" size="large" isLoading>Loading</TextButton>
          </div>
          
          <h4>Text</h4>
          <div className="component-demo">
            <TextButton variant="text" size="small">Small</TextButton>
            <TextButton variant="text" size="medium">Medium</TextButton>
            <TextButton variant="text" size="large">Large</TextButton>
          </div>
          
          <div className="component-demo">
            <TextButton variant="text" size="small" isLoading>Loading</TextButton>
            <TextButton variant="text" size="medium" isLoading>Loading</TextButton>
            <TextButton variant="text" size="large" isLoading>Loading</TextButton>
          </div>
        </div>
        
        <div className="style-guide-subsection">
          <h3>Icon Only Buttons</h3>
          
          <h4>Primary</h4>
          <div className="component-demo">
            <IconButton 
              variant="primary" 
              icon={addIcon}
              size="small"
              aria-label="Add item"
            />
            <IconButton 
              variant="primary" 
              icon={addIcon}
              size="medium"
              aria-label="Add item"
            />
            <IconButton 
              variant="primary" 
              icon={addIcon}
              size="large"
              aria-label="Add item"
            />
          </div>
          
          <div className="component-demo">
            <IconButton 
              variant="primary" 
              size="small"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="primary" 
              size="medium"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="primary" 
              size="large"
              isLoading
              aria-label="Loading"
            />
          </div>
          
          <h4>Secondary</h4>
          <div className="component-demo">
            <IconButton 
              variant="secondary" 
              icon={closeIcon}
              size="small"
              aria-label="Close"
            />
            <IconButton 
              variant="secondary" 
              icon={closeIcon}
              size="medium"
              aria-label="Close"
            />
            <IconButton 
              variant="secondary" 
              icon={closeIcon}
              size="large"
              aria-label="Close"
            />
          </div>
          
          <div className="component-demo">
            <IconButton 
              variant="secondary" 
              size="small"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="secondary" 
              size="medium"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="secondary" 
              size="large"
              isLoading
              aria-label="Loading"
            />
          </div>
          
          <h4>Text</h4>
          <div className="component-demo">
            <IconButton 
              variant="text" 
              icon={addIcon}
              size="small"
              aria-label="Add item"
            />
            <IconButton 
              variant="text" 
              icon={addIcon}
              size="medium"
              aria-label="Add item"
            />
            <IconButton 
              variant="text" 
              icon={addIcon}
              size="large"
              aria-label="Add item"
            />
          </div>
          
          <div className="component-demo">
            <IconButton 
              variant="text" 
              size="small"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="text" 
              size="medium"
              isLoading
              aria-label="Loading"
            />
            <IconButton 
              variant="text" 
              size="large"
              isLoading
              aria-label="Loading"
            />
          </div>
        </div>
        
        <div className="style-guide-subsection">
          <h3>Text with Icon Buttons</h3>
          
          <h4>Primary</h4>
          <div className="component-demo">
            <IconTextButton 
              variant="primary" 
              icon={addIcon}
              iconAlt="Add"
              size="small"
            >
              Add Item
            </IconTextButton>
            <IconTextButton 
              variant="primary" 
              icon={addIcon}
              iconAlt="Add"
              size="medium"
            >
              Add Item
            </IconTextButton>
            <IconTextButton 
              variant="primary" 
              icon={addIcon}
              iconAlt="Add"
              size="large"
            >
              Add Item
            </IconTextButton>
          </div>
          
          <div className="component-demo">
            <IconTextButton 
              variant="primary" 
              size="small"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="primary" 
              size="medium"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="primary" 
              size="large"
              isLoading
            >
              Loading
            </IconTextButton>
          </div>
          
          <h4>Secondary</h4>
          <div className="component-demo">
            <IconTextButton 
              variant="secondary" 
              icon={closeIcon}
              iconAlt="Close"
              size="small"
            >
              Cancel
            </IconTextButton>
            <IconTextButton 
              variant="secondary" 
              icon={closeIcon}
              iconAlt="Close"
              size="medium"
            >
              Cancel
            </IconTextButton>
            <IconTextButton 
              variant="secondary" 
              icon={closeIcon}
              iconAlt="Close"
              size="large"
            >
              Cancel
            </IconTextButton>
          </div>
          
          <div className="component-demo">
            <IconTextButton 
              variant="secondary" 
              size="small"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="secondary" 
              size="medium"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="secondary" 
              size="large"
              isLoading
            >
              Loading
            </IconTextButton>
          </div>
          
          <h4>Text</h4>
          <div className="component-demo">
            <IconTextButton 
              variant="text" 
              icon={addIcon}
              iconAlt="Add"
              size="small"
            >
              Add Item
            </IconTextButton>
            <IconTextButton 
              variant="text" 
              icon={addIcon}
              iconAlt="Add"
              size="medium"
            >
              Add Item
            </IconTextButton>
            <IconTextButton 
              variant="text" 
              icon={addIcon}
              iconAlt="Add"
              size="large"
            >
              Add Item
            </IconTextButton>
          </div>
          
          <div className="component-demo">
            <IconTextButton 
              variant="text" 
              size="small"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="text" 
              size="medium"
              isLoading
            >
              Loading
            </IconTextButton>
            <IconTextButton 
              variant="text" 
              size="large"
              isLoading
            >
              Loading
            </IconTextButton>
          </div>
        </div>
        
        <div className="style-guide-subsection">
          <h3>Button States</h3>
          
          <h4>Disabled Buttons</h4>
          <div className="component-demo">
            <TextButton variant="primary" disabled>Primary</TextButton>
            <TextButton variant="secondary" disabled>Secondary</TextButton>
            <TextButton variant="text" disabled>Text</TextButton>
          </div>
          
          <div className="component-demo">
            <IconButton 
              variant="primary" 
              icon={addIcon}
              disabled
              aria-label="Add item"
            />
            <IconButton 
              variant="secondary" 
              icon={closeIcon}
              disabled
              aria-label="Close"
            />
            <IconButton 
              variant="text" 
              icon={addIcon}
              disabled
              aria-label="Add item"
            />
          </div>
          
          <div className="component-demo">
            <IconTextButton 
              variant="primary" 
              icon={addIcon}
              iconAlt="Add"
              disabled
            >
              With Icon
            </IconTextButton>
            <IconTextButton 
              variant="secondary" 
              icon={closeIcon}
              iconAlt="Close"
              disabled
            >
              With Icon
            </IconTextButton>
            <IconTextButton 
              variant="text" 
              icon={addIcon}
              iconAlt="Add"
              disabled
            >
              With Icon
            </IconTextButton>
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="inputs" className="style-guide-section-title">Form Elements</h2>
        <h3>Input</h3>
        <div className="component-demo">
          <div style={{ width: '300px' }}>
            <Input
              label="Standard Input"
              placeholder="Enter text here"
            />
          </div>
          <div style={{ width: '300px' }}>
            <Input
              label="Input with Error"
              placeholder="Enter text here"
              error="This field is required"
            />
          </div>
          <div style={{ width: '300px' }}>
            <Input
              label="Disabled Input"
              placeholder="Enter text here"
              disabled
            />
          </div>
        </div>
        
        <h3>TextArea</h3>
        <div className="component-demo">
          <div style={{ width: '300px' }}>
            <TextArea
              label="Standard TextArea"
              placeholder="Enter text here"
              rows={3}
            />
          </div>
          <div style={{ width: '300px' }}>
            <TextArea
              label="TextArea with Error"
              placeholder="Enter text here"
              error="This field is required"
              rows={3}
            />
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="dialog" className="style-guide-section-title">Dialog</h2>
        <div className="component-demo">
          <TextButton onClick={() => setDialogOpen(true)}>Open Dialog</TextButton>
          <Dialog
            isOpen={dialogOpen}
            onClose={() => setDialogOpen(false)}
            title="Example Dialog"
            actions={
              <>
                <TextButton 
                  variant="secondary" 
                  onClick={() => setDialogOpen(false)}
                >
                  Cancel
                </TextButton>
                <TextButton 
                  variant="primary" 
                  onClick={() => setDialogOpen(false)}
                >
                  Confirm
                </TextButton>
              </>
            }
          >
            <p>This is an example dialog with some content.</p>
            <p>Dialogs can contain any content, including forms, text, and other components.</p>
          </Dialog>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="shadows" className="style-guide-section-title">Shadows</h2>
        <div className="shadow-grid">
          <div className="shadow-item">
            <div className="shadow-sample shadow-card"></div>
            <div className="shadow-info">
              <div className="shadow-name">Card</div>
              <div className="shadow-var">--shadow-card</div>
            </div>
          </div>
          <div className="shadow-item">
            <div className="shadow-sample shadow-resting"></div>
            <div className="shadow-info">
              <div className="shadow-name">Resting</div>
              <div className="shadow-var">--shadow-resting</div>
            </div>
          </div>
          <div className="shadow-item">
            <div className="shadow-sample shadow-flying"></div>
            <div className="shadow-info">
              <div className="shadow-name">Flying</div>
              <div className="shadow-var">--shadow-flying</div>
            </div>
          </div>
          <div className="shadow-item">
            <div className="shadow-sample shadow-window"></div>
            <div className="shadow-info">
              <div className="shadow-name">Window</div>
              <div className="shadow-var">--shadow-window</div>
            </div>
          </div>
        </div>
      </section>

      <section className="style-guide-section">
        <h2 id="checkboxes" className="style-guide-section-title">Checkboxes</h2>
        <div className="component-demo" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" />
              <span>Default Checkbox</span>
            </label>
          </div>
          <div>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" checked />
              <span>Checked Checkbox</span>
            </label>
          </div>
          <div>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" disabled />
              <span>Disabled Checkbox</span>
            </label>
          </div>
          <div>
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" checked disabled />
              <span>Checked Disabled Checkbox</span>
            </label>
          </div>
        </div>
      </section>

    </div>
  );
};

export default StyleGuide; 